import { DatePipe } from '@angular/common';
import { ComponentBase } from '../../common/component-base';
import { VersionLog } from './model/version-log';
import { VersionLogService } from './version-log.service';
import { Component, signal } from '@angular/core';
import { LoaderComponent } from '../../common/component/loader/loader.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'gate-version-log',
  standalone: true,
  imports: [LoaderComponent, TranslatePipe, DatePipe],
  templateUrl: './version-log.component.html',
  styleUrls: ['./version-log.component.scss']

})
export class VersionLogComponent extends ComponentBase {
  public allVersionLogs = signal<VersionLog[]>([]); // Signal to hold the list of version logs
  public versionLogs = signal<VersionLog[]>([]); // Signal to hold the list of version logs
  constructor(private versionLogService: VersionLogService, private translateService: TranslateService) {
    super();
    this.getVersionLog();
    this.translateService.onLangChange.subscribe((e) => {
       this.filterVersion();
    });
  }

  private getVersionLog() {
    this.SetLoading(true); // Set loading state to true
    this.versionLogService
      .getVersionLog()
      .then((result: VersionLog[]) => {
        this.allVersionLogs.set([...this.sortVersionLogs(result)]); // Update the serviceReports signal
        this.filterVersion();
        this.SetLoading(false); // Set loading state to false
      })
      .catch((error) => {
        this.SetLoading(false); // Set loading state to false
        console.error('Error fetching getVersionLog:', error); // Log error to console
      });
  }

  private filterVersion(){
    this.versionLogs.set([...this.allVersionLogs().filter(x=>x.language ==this.translateService.currentLang)]);
  }

sortVersionLogs(versionLogs: VersionLog[]) {
  return versionLogs.sort((a, b) => {
    const majorA = a.version?.major ?? 0;
    const minorA = a.version?.minor ?? 0;
    const patchA = a.version?.patch ?? 0;

    const majorB = b.version?.major ?? 0;
    const minorB = b.version?.minor ?? 0;
    const patchB = b.version?.patch ?? 0;

    // Compare major versions first
    if (majorB != majorA) {
      return majorB - majorA;
    }

    // Then compare minor versions
    if (minorB != minorA) {
      return minorB - minorA;
    }

    // Then compare patch versions
    return patchB - patchA;
  });
}
}
